<template>
    <div ref="modalEl" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" :class="dialogClass" :style="dialogStyle" role="document">
            <!-- <div class="modal-content"> -->
            <component v-if="active" :is="active.component" v-bind="active.props" :input="active.input" @resolve="onResolve" @reject="onReject" />
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
import modalService from '@/plugins/modal/service'

export default {
    name: 'ModalHost',
    data() {
        return {
            active: null,
            $modal: null
        }
    },
    computed: {
        dialogClass() {
            const opt = this.active?.options || {}
            return [
                opt.size === 'sm' && 'modal-sm',
                opt.size === 'lg' && 'modal-lg',
                opt.size === 'xl' && 'modal-xl',
                opt.centered && 'modal-dialog-centered',
                opt.scrollable && 'modal-dialog-scrollable',
                opt.customSize && 'modal-dialog-custom'
            ].filter(Boolean)
        },



        dialogStyle() {
            const opt = this.active?.options || {}
            const cs = opt.customSize
            if (!cs) return {}
            return {
                '--modal-width': cs.width || '',
                '--modal-max-width': cs.maxWidth || '',
                '--modal-min-width': cs.minWidth || ''
            }
        }

    },
    mounted() {
        this.active = modalService.state.active

        this.unsubShow = modalService.on('need-show', () => this.bsShow())
        this.unsubHide = modalService.on('need-hide', () => this.bsHide())
        this.unsubChange = modalService.on('change', ({ active }) => { this.active = active })

        this.initJQueryModal()

        this.$modal.on('hidden.bs.modal', () => {
            modalService.finalizeAfterHidden('dismiss')
        })
    },
    beforeDestroy() {
        this.unsubShow && this.unsubShow()
        this.unsubHide && this.unsubHide()
        this.unsubChange && this.unsubChange()

        if (this.$modal) {
            this.$modal.off('hidden.bs.modal')
            this.$modal.modal('dispose')
        }
    },
    methods: {
        initJQueryModal() {
            const el = this.$refs.modalEl

            if (!window.$) {
                console.warn('[ModalHost] jQuery ($) not found.')
                return
            }

            this.$modal = window.$(el)
            this.$modal.modal({
                show: false,
                backdrop: true,
                keyboard: true
            })
        },

        bsShow() {
            if (!this.$modal) this.initJQueryModal()

            const opt = this.active?.options || {}
            const backdrop = opt.backdrop ?? true
            const keyboard = opt.keyboard ?? true

            this.$modal.modal('dispose')

            this.$modal.modal({
                show: false,
                backdrop,
                keyboard
            })

            this.$modal.modal('show')
        },

        bsHide() {
            this.$modal && this.$modal.modal('hide')
        },

        onResolve(payload) {
            modalService.requestResolve(payload)
        },

        onReject(payload) {
            modalService.requestReject(payload)
        }
    }
}
</script>
<style scoped>
.modal-dialog.modal-dialog-custom {
    width: var(--modal-width, auto);
    max-width: var(--modal-max-width, none);
    min-width: var(--modal-min-width, auto);
}
</style>